const geocoder = () => {
  if (!window.google) throw new Error('Cannot find google api');

  return new window.google.maps.Geocoder();
};

const findByPlaceId = placeId =>
  new Promise(resolve => {
    geocoder().geocode({ placeId }, (results, status) => {
      if (status === window.google.maps.GeocoderStatus.OK) {
        const place = results[0];
        resolve({
          placeId,
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        });
      } else {
        console.error('findByPlaceId error');
      }
    });
  });

export { findByPlaceId };
